module.exports = __webpack_public_path__ + "img/NC.15a4d024.png";